import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalFormat',
})
export class DecimalFormatPipe implements PipeTransform {
  transform(value: string | number, isRounded: boolean): string {
    if (isNaN(parseFloat(value as string))) return value as string;

    if (isRounded) {
      return String(Math.round(parseFloat(value as string) * 100) / 100);
    }
    return parseFloat(Number(value).toFixed(2)).toLocaleString(this.getLocale(), {
      minimumFractionDigits: Number(value) % 1 === 0 ? 0 : 2,
    });
  }

  private getLocale(): string {
    return window.location.hostname.includes('mx') ? 'es-MX' : 'es-ES';
  }
}
